<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-stats-pie">
    <div class="wy-stats-pie-title">{{title}}</div>
    <div v-bind:id="pieCharId" />
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-stats-pie',
  props: ['title', 'parent', 'traceKey', 'traceList'],

  data() {
    return {
      dataList: {},
      pieCharId: ''
    }
  },

  watch: {
    traceKey() {
      this.buildChart();
    },

    traceList() {
      this.buildChart();
    },
  },

  methods: {
    buildChart() {
      if(this.traceList) {
        let pieLabels = this.traceList.map(el => el.label);
        let pieValues = this.traceList.map(el => el.value);
        let pieColors = this.traceList.map(el => el.color);

        let chartData = [{
          type: 'pie',
          labels: pieLabels,
          values: pieValues,
          marker: {
            colors: pieColors,
            
          },
          textposition: "none",
          //automargin: true,
          hoverinfo: 'none',
          hole: 0.70,
          texttemplate: '   %{percent}   '
        }];

        let chartLayout = {
          // title: pieLabels[0],
          autosize: true,
          // width: '350',
          height: '150',
          
          paper_bgcolor: '#FCFEFF',
          showlegend: false,
          annotations: [
            {
              text: pieValues[0] + '%',
              showarrow: false,
              font: {
                size: 20,
                color: '#214586',
              }
            }
          ],
          margin: { l: 30, r: 20, t: 20, b: 0 },
          legend: {
            orientation: 'h'
          }
        };
        if(chartData[0].labels.length >= 5){
          chartLayout.legend.font = {size: 8};
          chartLayout.margin = { l: 0, r: 0, t: 20, b: 0 };
          chartLayout.legend.y = -0.2;
          chartData[0].textfont = {size: 8};
        }
        let chartConfig = {responsive: true, displayModeBar: false, scrollZoom: false};
        // eslint-disable-next-line no-undef
        Plotly.newPlot(this.pieCharId, chartData, chartLayout, chartConfig);

        let plotPieChart = document.querySelector(this.pieCharId);
        if(plotPieChart) {
          plotPieChart.on('plotly_click', (data) => {
            if(data && data.points && data.points.length > 0){
              let label = data.points[0].label;
              this.parent.drillDownList.forEach(element => {
                if(element.drilldownId && element.label == label){
                  this.parent.drillDownKeySelected = element.drilldownId;
                }
              });
            }
          });
        }
      }
    }
  },

  created() {
    if(this.traceKey) {
      this.pieCharId = 'wy-stats-pie-chart-' + this.traceKey;
    }
  }
});
</script>

<style lang="scss">
  .wy-stats-pie {
    .wy-stats-pie-title {
      font-size: 14px;
      font-weight: 500;
      padding-bottom: 5px;
      padding-left: 12px;
      height: 38px;
      max-width: 160px;
    }
  }
</style>